import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolder2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconFolder2"><Path d="M2 5.75C2 4.23122 3.23122 3 4.75 3H9.13202C9.84832 3 10.5364 3.27949 11.0497 3.779L11.9407 4.64591C12.1741 4.87296 12.4868 5 12.8124 5H19.25C20.7688 5 22 6.23122 22 7.75V9.29985C21.625 9.10814 21.2001 9 20.75 9H3.25C2.79989 9 2.37503 9.10814 2 9.29985V5.75Z" fill="currentColor"/><Path d="M2 11.75V17.25C2 18.7688 3.23122 20 4.75 20H19.25C20.7688 20 22 18.7688 22 17.25V11.75C22 11.0596 21.4404 10.5 20.75 10.5H3.25C2.55964 10.5 2 11.0596 2 11.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolder2;
